module.exports = __webpack_public_path__ + "img/Large-Bevel-Attachment-25.a99b79bf.png";